<template>
  <div class="myReport">
    <div class="desc-class" id="PDFID">
      <input id="isApp" type="text" />
      <div class="userInfo">
        <span>用户名:{{ testData.data.name }}</span>
        <span v-if="isShowMobile">手机号:{{ testData.data.mobile }}</span>
        <span v-if="isApp"
          ><img @click="copyLink()" src="../assets/icon-share.png" alt=""
        /></span>
        <p
          v-if="
            $route.query.src != 3 &&
            testData.dataRowRealNum >= 210 &&
            testData.dataRowRealNum <= 840
          "
        >
          实际测评的有效时长未达到建议测评时长，报告仅供参考。
        </p>
        <p
          v-if="
            $route.query.src == 3 &&
            testData.dataRowRealNum >= 60 &&
            testData.dataRowRealNum <= 300
          "
        >
          实际测评的有效时长未达到建议测评时长，报告仅供参考。
        </p>
      </div>

      <div
        v-if="
          ($route.query.src != 3 && testData.dataRowRealNum >= 210) ||
          ($route.query.src == 3 && testData.dataRowRealNum >= 60)
        "
      >
        <div v-if="version == 'C'">
          <ReportDescCard :reviceData="card1Dict" />
          <ReportDescCard :reviceData="card2Dict" />
          <ReportDescCard :reviceData="card3Dict" />
          <ReportDescCard :reviceData="card4Dict" />
          <ReportDescCard :reviceData="card5Dict" />
        </div>

        <div class="header">
          <section class="header-prompt" v-if="version == 'C'">
            能量走势图:
          </section>
          <PieCharts
            v-if="version == 'C'"
            :option="kLineData2"
            style="width: 100%; height: 250px"
          />
          <div v-if="version == 'C'" class="measuTime">
            本次测评时长{{ testData.data.duration }}
          </div>

          <section class="header-prompt">状态走势图:</section>
          <PieCharts
            :option="kLineData3"
            style="margin-left: -5%; width: 105%; height: 250px"
          />
          <div class="measuTime">本次测评时长{{ testData.data.duration }}</div>
        </div>

        <div class="middle">
          <section class="middle-prompt">情绪心境特征:</section>
          <PieCharts
            :option="pieData"
            style="width: 100%; height: 250px; margin-top: 10px"
          />
        </div>

        <div class="bottom" v-if="version == 'C'">
          <div class="bottom-index-top">
            <span>本次测评综合指数</span>
            <span>{{ testData.data.reportDate }}</span>
          </div>

          <div class="bottom-index-bottom">
            <van-rate color="#000" void-color="#eee" v-model="star" readonly />
            <span :style="{ color: testData.data.color }">{{
              testData.data.status
            }}</span>
          </div>
          <div class="bottom-line"></div>

          <div class="bottom-content">
            <div class="bottom-content-prompt">结果评价:</div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title1 }}</div>
                <van-rate
                  style="margin-top: -3px"
                  color="#000"
                  void-color="#eee"
                  v-model="decStar1"
                  readonly
                />
              </div>
              <p class="contentClass">{{ testData.data.dec_content1 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title2 }}</div>
                <van-rate
                  style="margin-top: -3px"
                  color="#000"
                  void-color="#eee"
                  v-model="decStar2"
                  readonly
                />
              </div>
              <p class="contentClass">{{ testData.data.dec_content2 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title3 }}</div>
                <van-rate
                  style="margin-top: -3px"
                  color="#000"
                  void-color="#eee"
                  v-model="decStar3"
                  readonly
                />
              </div>
              <p class="contentClass">{{ testData.data.dec_content3 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title4 }}</div>
                <van-rate
                  style="margin-top: -3px"
                  color="#000"
                  void-color="#eee"
                  v-model="decStar4"
                  readonly
                />
              </div>
              <p class="contentClass">{{ testData.data.dec_content4 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title5 }}</div>
                <van-rate
                  style="margin-top: -3px"
                  color="#000"
                  void-color="#eee"
                  v-model="decStar5"
                  readonly
                />
              </div>
              <p class="contentClass">{{ testData.data.dec_content5 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title6 }}</div>
                <van-rate
                  style="margin-top: -3px"
                  color="#000"
                  void-color="#eee"
                  v-model="decStar6"
                  readonly
                />
              </div>
              <p class="contentClass">{{ testData.data.dec_content6 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title7 }}</div>
              </div>
              <p class="contentClass">{{ testData.data.dec_content7 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title8 }}</div>
                <van-rate
                  style="margin-top: -3px"
                  color="#000"
                  void-color="#eee"
                  v-model="decStar8"
                  readonly
                />
              </div>
              <p class="contentClass">{{ testData.data.dec_content8 }}</p>
            </div>
          </div>

          <div class="bottom-suggest" v-if="isShowSuggest">
            <div>情绪寄语:</div>
            <div class="contentClass">{{ testData.data.suggest }}</div>
          </div>
          <div
            class="contentClass"
            style="font-size: 12px; text-align: right; padding-bottom: 20px"
          >
            该报告仅供参考，不作为诊断结果。
          </div>
        </div>

        <div class="bottom" v-else>
          <div class="bottom-index-top">
            <span>本次测评综合指数</span>
            <span>{{ testData.data.reportDate }}</span>
          </div>

          <div class="bottom-index-bottom">
            <van-rate color="#000" void-color="#eee" v-model="star" readonly />
            <span :style="{ color: testData.data.color }">{{
              testData.data.status
            }}</span>
          </div>
          <div class="bottom-line"></div>

          <div class="bottom-line"></div>
          <div class="bottom-content">
            <div class="bottom-content-prompt">结果评价:</div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title1 }}</div>
              </div>
              <p class="contentClass">{{ testData.data.dec_content1 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title2 }}</div>
              </div>
              <p class="contentClass">{{ testData.data.dec_content2 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title3 }}</div>
              </div>
              <p class="contentClass">{{ testData.data.dec_content3 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title4 }}</div>
              </div>
              <p class="contentClass">{{ testData.data.dec_content4 }}</p>
            </div>
            <div class="bottom-content-margin">
              <div style="display: flex">
                <div>{{ testData.data.dec_title5 }}</div>
              </div>
              <p class="contentClass">{{ testData.data.dec_content5 }}</p>
            </div>
          </div>
          <div class="bottom-suggest" v-if="isShowSuggest">
            <div>情绪寄语:</div>
            <div class="contentClass">{{ testData.data.suggest }}</div>
          </div>
          <div
            class="contentClass"
            style="font-size: 12px; text-align: right; padding-bottom: 20px"
          >
            该报告仅供参考，不作为诊断结果。
          </div>
        </div>

        <div class="line"></div>

        <!-- 推荐课程 -->
        <!-- <div class="videoBox" v-if="testData.videos && testData.videos.length > 0">
      <div class="video-title">
        <img src="../assets/report-video.png" alt />
        <span>推荐课程</span>
      </div>
      <div v-for="(item, index) in testData.videos" :key="index">
        <div class="video" @click="handlerRecommendedClass(item)">
          <div class="video-left">
            <img class="bg" :src="item.poster" />
            <img class="pay" src="../assets/report-play.png" />
          </div>
          <div class="video-right">
            <div class="title">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div> -->

        <!-- <div class="line"></div> -->

        <!-- 推荐产品 -->
        <!-- <div class="videoBox" v-if="testData.products && testData.products.length > 0">
      <div class="video-title">
        <img src="../assets/report-video.png" alt />
        <span>推荐产品</span>
      </div>
      <div v-for="(item, index) in testData.products" :key="index">
        <div class="video" @click="handlerRecommendedPro(item)">
          <div class="video-left">
            <img class="bg" :src="item.poster" />
          </div>
          <div class="video-right">
            <div class="title">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div> -->

        <!-- <div class="line"></div> -->

        <!-- 推荐医生 -->
        <!-- <div class="videoBox" v-if="testData.doctors && testData.doctors.length > 0">
      <div class="video-title">
        <img src="../assets/report-doc.png" alt />
        <span>推荐医生</span>
      </div>
      <div v-for="(item, index) in testData.doctors" :key="index">
        <div class="video" @click="handlerRecommendedDoc(item)">
          <div class="video-left">
            <img class="bg" :src="item.poster" />
          </div>
          <div class="video-right">
            <div class="title">{{ item.name }}</div>
          </div>
        </div>
      </div>
    </div> -->
      </div>
      <div
        class="emptyReport"
        v-if="
          ($route.query.src != 3 && testData.dataRowRealNum < 210) ||
          ($route.query.src == 3 && testData.dataRowRealNum < 60)
        "
      >
        实际测评的有效时长未达到建议测评时长，此报告为无效报告，请重新测评。
      </div>
    </div>
    <div class="pcExport" @click="exportPdf()" v-if="pcExport">打印PDF</div>
  </div>
</template>
<script type="text/javascript" src="https://file.lingximind.com/js/webView.js"></script>
<script>
import serivce from "@/utils/ajax";
import PieCharts from "@/components/Echarts/PieEcharts.vue";
import htmlToPdf from "../utils/html2canvas";
import ReportDescCard from "@/components/ReportDescCard.vue";

//渲染前映射
function mappingYData(oldYData) {
  var newYData = [];
  for (var i = 0; i < oldYData.length; i++) {
    if (oldYData[i] <= 1000) {
      newYData.push(oldYData[i]);
    } else if (oldYData[i] <= 3000) {
      newYData.push(Math.round(oldYData[i] / 5) + 800);
    } else {
      newYData.push(3000);
    }
  }
  return newYData;
}

//渲染前映射
function trueYData(item) {
  var trueItem;
  if (item <= 1000) {
    trueItem = item;
  } else if (item <= 1400) {
    trueItem = 5 * item - 4000;
  } else {
    trueItem = 3000;
  }
  return trueItem;
}

export default {
  name: "MyReport",
  components: {
    PieCharts,
    ReportDescCard,
  },
  data() {
    return {
      pcExport: false,
      isApp: false,
      decStar1: "",
      decStar2: "",
      decStar3: "",
      decStar4: "",
      decStar5: "",
      decStar6: "",
      decStar7: "",
      decStar8: "",
      version: "",
      card1Dict: {
        title: "SDNN指数:",
        content:
          "SDNN为窦性心搏RR间期（简称NN间期）的标准差,用来评估自主神经活性.",
        barColor: ["#FF0202", "#FF0202", "#FF0202"],
        lineValue: "",
        promptStatus: ["不好", "一般", "好"],
      },
      card2Dict: {
        title: "rMSSD:",
        content: "rMSSD为相邻RR间期差值的均方根,用来评估副交感神经活性.",
        barColor: ["#FF0000", "#CED000", "#21E100"],
        lineValue: "",
        promptStatus: ["不好", "一般", "好"],
      },
      card3Dict: {
        title: "PNN50:",
        content:
          "相邻RR间期之差大于50毫秒的个数占心博总数的百分比，用来评估心率变异性程度.",
        barColor: ["#FF0000", "#CED000", "#21E100"],
        lineValue: "",
        promptStatus: ["不好", "一般", "好"],
      },
      card4Dict: {
        title: "压力指数",
        content: "压力指数越低越好，指标越靠近绿色区域越好.",
        barColor: ["#FF0000", "#CED000", "#21E100"],
        lineValue: "",
        promptStatus: ["不好", "一般", "好"],
      },
      card5Dict: {
        title: "自主神经平衡性:",
        content: "",
        barColor: ["#029FF9", "#5DEF00", "#FF0202"],
        lineValue: "",
        promptStatus: ["副交感占优", "平衡", "交感占优"],
      },
      isShowMobile: false,
      isShowSuggest: false,
      kLineChartData: [],
      kLineTimeData: [],
      testData: { data: {} },
      star: 0,
      kLineData3: {
        tooltip: {
          trigger: "axis",
          //弹窗里需要换算成真实值
          formatter: function (params) {
            return `${
              params[0].axisValue
            }<br /><span style="display:inline-block;margin-right:5px;width:10px;height:10px;background:#ff7833;border-radius:5px;"></span>状态值：${trueYData(
              params[0].data
            )}`;
          },
          axisPointer: {
            type: "cross",
            animation: false,
            label: {
              backgroundColor: "#ccc",
              borderColor: "#aaa",
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              textStyle: {
                color: "#222",
              },
              formatter: function (params) {
                if (params.axisDimension === "y") {
                  return trueYData(Math.round(params.value));
                } else {
                  return params.value;
                }
              },
            },
          },
        },
        grid: {
          top: "20rpx",
          left: "100rpx",
          right: "20rpx",
          bottom: "20rpx",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: true,
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          max: 1400,
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "状态值",
            type: "line",
            smooth: true,
            data: [],
            symbol: "none",
            markLine: {
              symbol: "none",
              data: [
                {
                  name: "line1",
                  yAxis: 200,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "200",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line2",
                  yAxis: 400,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "400",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line3",
                  yAxis: 600,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "600",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line4",
                  yAxis: 800,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "800",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line5",
                  yAxis: 1000,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "1000",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line6",
                  yAxis: 1200,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "2000",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line7",
                  yAxis: 1400,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "3000",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
              ],
            },
          },
        ],
      },
      kLineData2: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            animation: false,
            label: {
              backgroundColor: "#ccc",
              borderColor: "#aaa",
              borderWidth: 1,
              shadowBlur: 0,
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              textStyle: {
                color: "#222",
              },
            },
          },
        },
        grid: {
          top: "20px",
          left: "60px",
          right: "20px",
          bottom: "20px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          show: true,
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          max: 200,
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: "sDNN",
            type: "line",
            smooth: true,
            data: [],
            symbol: "none",
            markLine: {
              symbol: "none",
              data: [
                {
                  name: "line1",
                  yAxis: 25,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "25",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line2",
                  yAxis: 50,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "50",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line3",
                  yAxis: 75,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "75",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line4",
                  yAxis: 100,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "100",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line5",
                  yAxis: 125,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "125",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line6",
                  yAxis: 150,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "150",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line6",
                  yAxis: 175,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "175",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
                {
                  name: "line7",
                  yAxis: 200,
                  label: {
                    normal: {
                      position: "start",
                      formatter: "200",
                    },
                  },
                  lineStyle: {
                    color: "#666",
                  },
                },
              ],
            },
          },
        ],
      },
      pieData: {
        color: ["#4DBD5E", "#F6513B", "#F6691D", "#196686", "#941B9A"],
        legend: {
          orient: "horizontal",
          selectedMode: true,
          left: "10%",
          top: "0px",
        },
        series: [
          {
            type: "pie",
            radius: ["40%", "60%"],
            // center: ["50%", "60%"],
            avoidLabelOverlap: true, // 是否启用防止标签重叠策略
            legendHoverLink: true,
            hoverAnimation: true, //是否开启 hover 在扇区上的放大动画效果。
            selectedMode: false,
            silent: false, //图形是否不响应和触发鼠标事件
            label: {
              normal: {
                show: true,
                formatter: "{per|{b}\n{d}%}",
                rich: {
                  per: {
                    fontSize: 12,
                  },
                },
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: 15,
                  fontWeight: "bold",
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
            clickable: true,
            data: [],
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.query.isApp) {
      this.isApp = true;
    }
    if (
      sessionStorage.getItem("PcPhone") &&
      sessionStorage.getItem("PcCompanyId")
    ) {
      this.pcExport = true;
    } else {
      if (this.$route.query.phone && this.$route.query.companyId) {
        sessionStorage.setItem("PcPhone", this.$route.query.phone);
        sessionStorage.setItem("PcCompanyId", this.$route.query.companyId);
        this.pcExport = true;
      } else {
        this.pcExport = false;
      }
    }
    const params = {
      id: this.$route.query.rid
        ? this.$route.query.rid
        : this.$route.query.qrscene_rid,
      src: this.$route.query.src,
    };
    this.getData(params);
    console.log();
  },
  methods: {
    copyLink() {
      /* 获取文本内容 */
      // var copyText = document.getElementById("isApp"); /* 选择复制内容 */
      // copyText.select();
      // copyText.setSelectionRange(
      //   0,
      //   99999
      // );

      // navigator.clipboard.writeText(location.href);
      // this.$toast("复制成功");

      document.addEventListener("UniAppJSBridgeReady", function () {
        uni.postMessage({
          data: {
            action: "postMessage",
          },
        });
      });
    },
    exportPdf() {
      htmlToPdf.download(
        document.getElementById("PDFID"),
        `${this.testData.data.name}测评报告`
      );
    },
    handlerRecommendedClass(e) {
      const params = {
        playSrc: e.src,
        playName: e.name,
        from: "点滴灵犀",
      };
      this.$router.push({ path: "/VideoView", query: params });
    },
    handlerRecommendedPro(e) {
      window.location.href = e.src;
      // this.$dialog
      //   .alert({
      //     title: "复制该链接去浏览器访问",
      //     message: e.src,
      //     confirmButtonText: "复制",
      //   })
      //   .then(() => {
      //     this.$toast("复制成功");
      //   });
    },
    handlerRecommendedDoc(e) {
      window.location.href = e.src;
      // this.$dialog
      //   .alert({
      //     title: "复制该链接去浏览器访问",
      //     message: e.src,
      //     confirmButtonText: "复制",
      //   })
      //   .then(() => {
      //     this.$toast("复制成功");
      //   });
    },
    async getData(params) {
      serivce.get(`${process.env.VUE_APP_BASE_LX_API}/api/wx/join/detail`, params).then((res) => {
        if (res.status == 200) {
          if (res.data.data.mobile == "") {
            this.isShowMobile = false;
          } else {
            this.isShowMobile = true;
          }
          this.testData = res.data;
          // this.isShowSuggest = true
          this.isShowSuggest = res.data.data.suggest.length != 0 ? true : false;

          this.kLineData3.xAxis.data = JSON.parse(res.data.chart_time);
          this.kLineData3.series[0].data = mappingYData(
            JSON.parse(res.data.chart)
          );
          this.kLineData2.xAxis.data = JSON.parse(res.data.chart_time);
          this.kLineData2.series[0].data = JSON.parse(res.data.chart_sdnn);

          this.card1Dict.title = "SDNN指数:  " + res.data.data.sdnn;
          this.card1Dict.lineValue = res.data.data.sdnnPercent;

          this.card2Dict.title = "rMSSD:  " + res.data.data.rmssd;
          this.card2Dict.lineValue = res.data.data.rmssdPercent;

          this.card3Dict.title = "PNN50:  " + res.data.data.pnn50 + "%";
          this.card3Dict.lineValue = res.data.data.pnn50Percent;

          this.card4Dict.title = "压力指数:  " + res.data.data.sii;
          this.card4Dict.lineValue = res.data.data.siiPercent;

          this.card5Dict.title = "自主神经平衡性:";
          this.card5Dict.lineValue = res.data.data.snPercent;

          this.version = res.data.data.version;

          let pies = res.data.pie;
          this.pieData.series[0].data = [
            {
              value: Number(pies[0]) === 0 ? "低沉" : Number(pies[0]),
              name: "平静",
            },
            {
              value: Number(pies[1]) === 0 ? "平静" : Number(pies[1]),
              name: "焦虑",
            },
            {
              value: Number(pies[2]) === 0 ? "饱满" : Number(pies[2]),
              name: "不安",
            },
            {
              value: Number(pies[3]) === 0 ? "不安" : Number(pies[3]),
              name: "饱满",
            },
            {
              value: Number(pies[4]) === 0 ? "焦虑" : Number(pies[4]),
              name: "低沉",
            },
          ];
          this.star = Number(this.testData.data.star);
          this.decStar1 = Number(this.testData.data.dec_star1);
          this.decStar2 = Number(this.testData.data.dec_star2);
          this.decStar3 = Number(this.testData.data.dec_star3);
          this.decStar4 = Number(this.testData.data.dec_star4);
          this.decStar5 = Number(this.testData.data.dec_star5);
          this.decStar6 = Number(this.testData.data.dec_star6);
          this.decStar7 = Number(this.testData.data.dec_star7);
          this.decStar8 = Number(this.testData.data.dec_star8);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.myReport {
  font-family: "Microsoft YaHei";
  position: relative;
  .pcExport {
    position: absolute;
    font-size: 0.16rem;
    top: 0.06rem;
    right: 32%;
    background: #008d7d;
    color: #fff;
    padding: 0.05rem 0.2rem;
    border-radius: 0.08rem;
    cursor: pointer;
  }
}
.videoBox {
  border-top: 1px solid white;
  background: rgba(253, 210, 60, 1);
  padding: 10px 0;
}

.video-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  margin-left: 20px;
  span {
    font-size: 0.34rem;
  }
}

.video-title img {
  width: 21px;
  height: 21px;
}

.video-img {
  width: 30px;
  height: 30px;
}

.video {
  background: whitesmoke;
  height: 103px;
  display: flex;
  flex-direction: row;
  align-items: left;
  justify-content: left;
  margin: 10px;
  position: relative;
}

.video-left {
  height: 103px;
  width: 170px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.video-left .bg {
  height: 95%;
  width: 160px;
  border-radius: 10px;
}

.video-left .pay {
  height: 39px;
  width: 39px;
  position: absolute;
  top: 30px;
  cursor: pointer;
}

.video-right {
  height: 103px;
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  margin: 10px;
}

.video-right .title {
  color: rgba(74, 74, 74, 1);
  font-size: 17px;
}

.video-right .content {
  color: rgba(74, 74, 74, 1);
  font-size: 13px;
  flex: 0.7;
  padding: 6px 0px;
}

.desc-class {
  max-width: 750px;
  // height: 800px;
  margin: 0 auto;
  overflow: scroll;
}
#isApp {
  position: fixed;
  top: -9999px;
}
.userInfo {
  margin: 10px;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-items: center;
  :nth-child(1) {
    margin-right: 30px;
  }
  p {
    width: 100%;
    margin: 0;
    margin-top: 5px;
    font-size: 14px;
  }
  // :last-child {
  //   text-align: right;
  // }

  img {
    margin-left: 10px;
    width: 0.3rem;
    position: absolute;
    right: -0.3rem;
    top: 0.1rem;
  }
}

.header {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  .header-prompt {
    margin: 20px 0 0 20px;
  }
  .measuTime {
    font-size: 14px;
    text-align: center;
  }
}

.middle {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  .middle-prompt {
    margin: 20px 0 0 20px;
  }
}

.bottom {
  font-size: 16px;
  font-weight: 600;
  background-color: rgb(253, 210, 60);
  .bottom-index-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 20px 20px 0 20px;
  }
  .bottom-index-bottom {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 20px 10px 20px;
    border-bottom: 1px solid white;
  }

  .bottom-content {
    border-bottom: 1px solid white;
    padding: 20px 20px 0 20px;
    .bottom-content-margin {
      font-size: 16px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .contentClass {
      margin-top: 0;
      font-size: 14px;
    }
  }

  .bottom-suggest {
    padding: 20px;
    .bottom-suggest-text {
      font-size: 16px;
    }
    .contentClass {
      font-size: 14px;
    }
  }
}

.ant-rate {
  color: black;
}
.emptyReport {
  margin: 150px 30px 0 30px;
  font-size: 22px;
}
</style>
